import React, { Component } from 'react';
import { getItem } from 'utils/localStorage';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import CoachRegistration from 'components/CoachRegistration';
import ResetPassword from 'components/ResetPassword';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import ModifyStudent from 'components/ModifyStudent';
import ModifyParent from 'components/ModifyParent';
import Billings from 'components/Billings';
import styles from './SettingsView.scss';// to import local scss fle


class SettingsView extends Component {
  static propTypes = {
    tab: PropTypes.number,
    usedFor: PropTypes.string,
    attributes: PropTypes.shape(),
  };
  static defaultProps = {
    tab: 0,
    usedFor: '',
    attributes: {},
  };
  constructor(props) {
    super(props);
    this.state = {
      localZone: '',
    };
  }

  componentWillMount() {
    const currentLocalZone = getItem('localZone');
    if (currentLocalZone === 'STUDENT') {
      this.setState({ localZone: currentLocalZone });
    } else {
      this.setState({ localZone: currentLocalZone });
    }
  }

  componentWillReceiveProps() {
    const currentLocalZone = getItem('localZone');
    if (currentLocalZone === 'STUDENT') {
      this.setState({ localZone: currentLocalZone });
    } else {
      this.setState({ localZone: currentLocalZone });
    }
  }

  render() {
    const renderDefault = renderIf(this.props.tab === 0);
    const renderResetPassword = renderIf(this.props.tab === 1);
    const renderBillings = renderIf(this.props.tab === 2);
    const renderCoachProfile = renderIf(this.props.usedFor === 'coach' || this.state.localZone === 'COACH');
    const renderParentProfile = renderIf(this.props.attributes.get('zoneinfo') === 'PARENT');
    const renderAthleteProfile = renderIf(this.props.usedFor === 'athlete' &&
        (this.props.attributes.get('zoneinfo') === 'STUDENT' || this.state.localZone === 'STUDENT'));
    return (
      <div className={cn('row', styles.container)}>
        {renderDefault(
          <div className={cn('col s12', styles.profileContainer)}>
            {renderCoachProfile(
              <div>
                <CoachRegistration {...this.props} usedFor="modify" />
              </div>,
              )}
            {renderAthleteProfile(
              <div>
                <ModifyStudent {...this.props} />
              </div>,
              )}
            {renderParentProfile(
              <ModifyParent {...this.props} />,
              )}
          </div>,
        )}
        {renderResetPassword(
          <div>
            <ResetPassword {...this.props} />
          </div>,
        )}
        {renderBillings(
          <div>
            <Billings {...this.props} />
          </div>,
        )}


      </div>
    );
  }
}

export default SettingsView;



// WEBPACK FOOTER //
// ./src/components/SettingsView/SettingsView.js